import BoardMembershipPermissionsSelectStep from './BoardMembershipPermissionsSelectStep';

export default BoardMembershipPermissionsSelectStep;
